let number = 0;

export default function getUniqueNumber() {
  return number++;
}
